export const LOGIN_MODAL_NAME = 'login';
export const OTHER_PROVIDER_MODAL_NAME = 'other_provider';
export const LOGIN_STEP_1 = 1;
export const LOGIN_STEP_2 = 2;
export const LOGIN_STEP_3 = 3;
export const LOGIN_STEP_4 = 4;
export const CONTACT_DETAILS_MODAL = 'contact_details';
export const DONE_MODAL = 'done_modal';
export const ADD_TICKETS_MODAL_NAME = 'add_tickets';
export const FORGOT_PASSWORD_MODAL_NAME = 'forgot_password';
